<template>
    <!--<div class="ModalBackground" style="display:block">
        <div class="ModalBackGroundPanel">
            <div class="header">
                <h1 class="Title">Analysis breakdown</h1>
                <div class="Options">
                    <i v-on:click.stop="$emit('closed')" class="el-icon-close" style="font-size:20px;"></i>
                </div>
            </div>
            -->
    <el-dialog title="Analysis breakdown" width="20% !important" v-model="DialogVisible" :close-on-click-modal="false" :close-on-press-escape="false">
        <div autocomplete="off" data-form-type="other">
            <table class="Breakdown">
                <thead>
                    <tr>
                        <th>&nbsp;</th>
                        <th width="40"></th>
                        <th v-for="(p) in ProviderSelection" :key="p.quoteID">{{ p.displayName }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="categoryHeaderRow">
                        <td colspan="2">Cost</td>
                        <td v-for="(p) in ProviderSelection" :key="'Price' + p.quoteID">&pound;{{ p.price.toFixed(2) }}</td>
                    </tr>
                    <tr>
                        <td colspan="2">Overall Quality Score</td>
                        <td v-for="(p) in ProviderSelection" :key="'Overall' + p.quoteID">
                            {{ Round(Analysis.providerScores[p.apiProductId]) }}
                        </td>
                    </tr>
                    <tr class="separaterRow">
                        <td :colspan="2 + ProviderSelection.length">
                            Underlying Feature Quality Scores
                        </td>
                    </tr>
                </tbody>
                <tbody v-for="(categoryAnalysis, categoryName) in Analysis.categoryAnalysis" :key="categoryName">
                    <tr class="categoryHeaderRow">
                        <td colspan="2" class="QuestionLevel0">
                            {{ categoryName }}
                        </td>
                        <td v-for="(p) in ProviderSelection" :key="'Category' + categoryName + '~' + p.quoteID">
                            {{ Round(categoryAnalysis.providerScores[p.apiProductId]) }}
                        </td>
                    </tr>
                    <tr v-for="feature in SortedArray(categoryAnalysis.featureAnalysis)"
                        :key="categoryName + '~' + feature.featureReference">
                        <td class="QuestionLevel0">
                            <div class="feature-details">
                                <span class="feature-name" v-if="GetFeatureDetails(feature.featureReference) && GetFeatureDetails(feature.featureReference).name">
                                    {{ GetFeatureDetails(feature.featureReference).name }}
                                </span>

                                <el-link v-if="GetFeatureDetails(feature.featureReference) && GetFeatureDetails(feature.featureReference).link"
                                         :href="GetFeatureDetails(feature.featureReference).link"
                                         target="_blank"
                                         class="find-out-more">
                                    Find out more
                                </el-link>
                            </div>
                        </td>
                        <td width="40">
                            <el-tooltip popper-class="tooltip-custom"
                                        v-if="GetFeatureDetails(feature.featureReference) && GetFeatureDetails(feature.featureReference).description"
                                        :content="GetFeatureDetails(feature.featureReference).description"
                                        placement="top">
                                <span class="tooltip-icon">?</span>
                            </el-tooltip>
                        </td>
                        <td v-for="(p) in ProviderSelection"
                            :key="'Category' + categoryName + '~' + feature.featureReference + '~' + p.quoteID">
                            {{ Round(feature.providerScores[p.apiProductId]) }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </el-dialog>
</template>
<style>
    .tooltip-custom.is-dark {
        max-width: 600px !important;
        height: auto !important;
        max-height: 300px !important;
        _overflow: auto !important;
        white-space: normal !important;
        word-wrap: break-word !important;
        background-color: #333 !important;
        color: white !important;
        padding: 10px !important;
        font-size: 12px !important;
        line-height: 18px !important;
        border-radius: 5px !important;
    }

        .tooltip-custom.is-dark .el-popper__arrow {
            border-top-color: #333 !important;
        }
</style>
<style scoped>
    table,
    td,
    th {
        border-collapse: collapse;
    }

    .header {
        border-bottom: none !important;
    }

    .Options {
        padding-right: 0px !important;
    }

    .ModalBackGroundPanel {
        overflow-y: auto !important;
    }

    .Title {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 700;
        font-size: 18px;
        line-height: 41px;
        letter-spacing: -0.04em;
        color: #0F172A;
    }

    table.Breakdown {
        width: 100%;
        border: 0px solid #181F6A;
        table-layout: fixed
    }

        table.Breakdown thead {
            width: 866px;
            height: 78px;
        }

            table.Breakdown thead tr th {
                text-align: center;
                background: #181F6A;
                border: 1px solid #181F6A;
                vertical-align: middle;
                font-family: 'Inter';
                font-style: normal;
                font-weight: 600;
                font-size: 14px;
                line-height: 19px;
                align-items: center;
                color: #FFFFFF;
            }

        table.Breakdown tbody tr td {
            text-align: center;
            vertical-align: middle;
            font-family: 'Inter';
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            line-height: 19px;
            color: #323A46;
            padding: 5px;
        }

            table.Breakdown tbody tr td:first-child {
                text-align: left;
                padding: 10px;
            }

        table.Breakdown tbody tr td,
        table.Breakdown thead tr th {
            height: 30px;
        }

    .Breakdown tr.separaterRow td {
        background: #BBCAF3;
        font-family: 'Inter';
        font-style: normal;
        font-weight: 700;
        font-size: 14px;
        line-height: 22px;
        align-items: center;
        color: #323A46;
        position: relative;
        width: 775px;
        height: 40px;
        text-transform: uppercase;
    }

    .Breakdown tr.categoryHeaderRow td {
        background: #F7F8F9;
    }

    .el-table .warning-row {
        background: oldlace;
    }

    .el-table .success-row {
        background: #f0f9eb;
    }

    .el-link {
        justify-content: flex-start;
        align-items: flex-start;
        text-decoration: none;
    }

    .feature-details {
        display: flex;
        flex-direction: column;
    }

    .tooltip-icon {
        cursor: pointer;
        font-weight: bold;
        background-color: #007bff;
        color: white;
        border-radius: 50%;
        width: 20px;
        height: 20px;
        display: inline-block;
        text-align: center;
        line-height: 20px;
    }

    .find-out-more {
        margin-top: 2px;
        font-weight: normal;
        text-decoration: none;
        color: #007bff;
    }

        .find-out-more:hover {
            text-decoration: none;
        }

    .el-link.el-link--default {
        text-decoration: none !important;
    }

        .el-link.el-link--default:hover::after {
            content: none !important;
        }
</style>
<script>
    //import $ from 'jquery';
    export default {
        name: 'AnalysisBreakdown',
        components: {},
        props: {
            analysis: {
                type: Object,
                default: null,
            },
            providerSelection: {
                type: Array,
                default: function () { return []; }
            },
            extendedFeatures: {
                type: Array,
                default: function () { return []; }
            },
            modelValue: {
                type: Boolean,
                default: true
            }
        },
        data: function () {
            return {
            }
        },
        methods: {
            Round: function (value) {
                var numericValue = Number(value);
                return Number.isFinite(numericValue) ? numericValue.toFixed(1) : '--';
            },
            SortedArray: function (featureAnalysis) {
                var source = (featureAnalysis !== null && typeof (featureAnalysis) === 'object')
                    ? Object.entries(featureAnalysis)
                    : [];

                return source
                    .map(([featureReference, feature]) => ({
                        ...feature,
                        featureReference
                    }))
                    .sort((a, b) => b.featureWeight - a.featureWeight);
            },
            GetFeatureDetails: function (reference) {
                if (!reference) {
                    return null;
                }

                var features = Array.isArray(this.ExtendedFeatures) ? this.ExtendedFeatures : [];
                const feature = features.find(function (a) {
                    return a.featureReference === reference;
                });

                return feature ? {
                    name: feature.featureName,
                    description: feature.featureDescription,
                    link: feature.featureDescriptionLink
                } : null;
            }
        },
        created: function () {

        },
        computed:
        {
            Analysis: function () {
                return this.analysis || { categoryAnalysis: {}, providerScores: {} };
            },
            ProviderSelection: function () {
                return Array.isArray(this.providerSelection)
                    ? this.providerSelection.filter(function (provider) { return provider !== undefined && provider !== null; })
                    : [];
            },
            ExtendedFeatures: function () {
                return Array.isArray(this.extendedFeatures) ? this.extendedFeatures : [];
            },
            DialogVisible: {
                get: function () {
                    return this.modelValue !== false;
                },
                set: function (value) {
                    this.$emit('update:modelValue', value);
                    if (value === false) {
                        this.$emit('closed');
                    }
                }
            },
        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
